import { IconTypes } from "./types";
import { ReactComponent as Slider } from "../../../../assets/icons/small/slider.svg";
import { ReactComponent as Warning } from "../../../../assets/icons/small/warning.svg";
import { ReactComponent as Clock } from "../../../../assets/icons/small/clock.svg";
import { ReactComponent as Container } from "../../../../assets/icons/small/container.svg";
import { ReactComponent as Play } from "../../../../assets/icons/small/play.svg";
import { ReactComponent as Check } from "../../../../assets/icons/small/check.svg";
import { ReactComponent as File } from "../../../../assets/icons/small/file.svg";
import { ReactComponent as Message } from "../../../../assets/icons/small/message.svg";
import { ReactComponent as ThumbsUp } from "../../../../assets/icons/small/thumbsUp.svg";
import { ReactComponent as MoreVertical } from "../../../../assets/icons/small/moreVertical.svg";
import { ReactComponent as Edit } from "../../../../assets/icons/small/edit.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/small/calendar.svg";
import { ReactComponent as Personnel } from "../../../../assets/icons/small/personnel.svg";
import { ReactComponent as Slash } from "../../../../assets/icons/small/slash.svg";
import { ReactComponent as HistoryDrawer } from "../../../../assets/icons/small/historyDrawer.svg";
import { ReactComponent as HistoryDrawerClose } from "../../../../assets/icons/small/historyDrawerClose.svg";

export const icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  // CHEVRONLEFT: <ChevronLeft />,
  SLIDER: <Slider />,
  WARNING: <Warning />,
  CLOCK: <Clock />,
  CONTAINER: <Container />,
  PLAY: <Play />,
  CHECK: <Check />,
  FILE: <File />,
  MESSAGE: <Message />,
  THUMBSUP: <ThumbsUp />,
  MOREVERTICAL: <MoreVertical />,
  EDIT: <Edit />,
  CALENDAR: <Calendar />,
  PERSONNEL: <Personnel />,
  SLASH: <Slash />,
  HISTORYDRAWER: <HistoryDrawer />,
  HISTORYDRAWERCLOSE: <HistoryDrawerClose />,
};
